// extracted by mini-css-extract-plugin
export var arrow = "y_9";
export var career = "y_cD";
export var careerContainer = "y_cC";
export var container = "y_b";
export var link = "y_by";
export var location = "y_cF";
export var section = "y_j";
export var title = "y_g";